import { LogService } from 'ng/src/app/logs/log.service';

angular.module('logbook')
.service('logDataService', ['$rootScope', '$http', '$q', '$location', 'shiftsService', 'onsiteSettingsService', 'simulateLogUserRoleService', 'logService',
   function($rootScope, $http, $q, $location, shiftsService, onsiteSettingsService, simulateLogUserRoleService, logService) {

      function setLogRole(log, role) {
         log.userRole = role;
         log.role = $rootScope.mapRole(role);
         if( log.activeLogUser )
             log.activeLogUser['role'] = log.userRole;
      };

      const service = {
         getLogData: function(log)
         {
            return $q.all([
               this.checkLogUser(log),
               this.getLogConfigs(log),
               this.checkSentinel(log),
               this.checkOnsite(log)
            ]);
         },
         checkLogUser: function(log)
         {
            return logService.getLogRoles().toPromise().then( function(logRoles) {
               return $http.get('/api/logUsers',
               { params: {
                  "log" : log.id,
                  "user" : $rootScope.user.id
               }}).then(function(result) {
                  let simulatedRoleId = simulateLogUserRoleService.getSimulatedLogUserRole(log.id);
                  if( simulateLogUserRoleService.forceAdminFlag
                      && (!result.data._embedded.logUsers.length || result.data._embedded.logUsers[0].role.id !== 3) ) {
                     simulatedRoleId = 3;
                  }
                  if( simulatedRoleId ) {
                      let originalLogRole = undefined;
                      if( result.data._embedded.logUsers.length )
                         originalLogRole = result.data._embedded.logUsers[0].role;
                      setLogRole(log, logRoles.find(role => role.id === simulatedRoleId));
                      log.simulatedRole = true;
                      log.cancelSimulatedRole = function() {
                         log.simulatedRole = false;
                         simulateLogUserRoleService.cancelForceAdmin();
                         simulateLogUserRoleService.simulateLogUserRole(log.id, undefined);
                         if( result.data._embedded.logUsers.length )
                            setLogRole(log, originalLogRole);
                         else {
                            $location.url('/');
                            delete $rootScope.selectedLog;
                            delete log.userRole;
                            delete log.role;
                            
                         }
                      }
                  }
                  else
                  {
                     setLogRole(log, result.data._embedded.logUsers[0].role);
                  }
                  if( !simulateLogUserRoleService.forceAdminFlag ) {
                     log.userDefaultTemplate = 
                        result.data._embedded.logUsers[0].defaultTemplate;
                     log.activeLogUser = result.data._embedded.logUsers[0];
                  } else {
                     log.activeLogUser = result.data._embedded.logUsers[0] || {
                         'user': {
                            'id': $rootScope.user ? $rootScope.user.id : undefined
                         }
                     };
                     log.activeLogUser['role'] = log.userRole;
                  }
               });
            });
         },
         
         getLogTemplates: function(log) {
            return $http.get('/api/templates',
               {
                  params: {
                     "log": log.id,
                     "hasUser": $rootScope.user.id,
                     "enterNotes": true,
                     "size": 10000
                  }
               }).then(function(result) {
				   log.templates = result.data._embedded.templates;
				   
				   LogService.templates = log.templates;
               });
         },
         
         getLogConfigs: function(log)
         {
            var deferred = $q.defer();
            if( !log || !log.id )
            {
               deferred.reject('no log selection');
               return deferred.promise;
            }
            $http.get('/api/logConfigs',
               { params: {
                  "log" : log.id,
                  "hierarchy" : 'logbook.webui.config'
               }}).then(function(result) {
                  var configs = result.data._embedded.logConfigs;
                  log.logConfigs = {};
                  log.logConfigHref = {};
                  configs.forEach(function(config) {
                     log.logConfigs[config.key] = config.value;
                     log.logConfigHref[config.key] = config._links.self.href;
                  })
                  deferred.resolve();
               });
            return deferred.promise;
         },

         checkSentinel: function (log) {
             var facilityParams = {
                 logId: log.id,
                 hierarchy: 'logbook.provision',
                 keyLike: 'Sentinel.instance.Facility%',
                 projection: 'idProjection',
                 size: 1
             };
             var doorParams = {
                   logId: log.logId,
                   hierarchy: 'logbook.provision',
                   keyLike: 'Sentinel.instance.Door%',
                   projection: 'idProjection',
                   size: 1
               };

             var deferred = $q.defer();
             if (log && log.millisToSentinelPaymentExpiration) {
                $q.all([
                 $http.get('/api/logConfigs', {params: facilityParams}),
                 $http.get('/api/logConfigs', {params: doorParams})
                 ]).then(function (response) {
                     if(response[0].data._embedded.logConfigs.length === 0
                        || response[1].data._embedded.logConfigs.length === 0) {
                         console.log("Setting sentinelProvisioned to false");
                         log.sentinelProvisioned = false;
                     } else {
                           console.log("Setting sentinelProvisioned to true");
                           log.sentinelProvisioned = true;
                      }
                     deferred.resolve();
                 });
             } else {
                 if(log) {
                     log.sentinelProvisioned = false;
                 }
                 deferred.resolve();
             }
             return deferred.promise;
         },

         checkOnsite: function(log){
            var deferred = $q.defer();
             if (log) {
                log.onsiteEnabled = log.millisToFeatureExpiration.OnSite && log.millisToFeatureExpiration.OnSite > 0;

                 if (log.onsiteEnabled) {
                      onsiteSettingsService.getOnSiteSettingsByLogId(log.id).then(function (settings) {
                        log.onsiteNumberProvisioned = settings.phoneNumber != null && settings.phoneNumber.trim().length > 0;
                        deferred.resolve();
                   });
                }
                else
                {
                   log.onsiteNumberProvisioned = false;
                   deferred.resolve();
                }
             }
             return deferred.promise;
         }
      };

      $rootScope.$on('simulated-log-role', () => {
          service.checkLogUser($rootScope.selectedLog).then(() => {
              logService.selectedLog = $rootScope.selectedLog;
          });
      });
      return service;
   }
]);
